module.exports = __webpack_public_path__ + "dicord-3587209a.webp";